import React, { useMemo } from 'react';
import {
    VentilationType,
    useUpdateProjectionVentilationMutation,
} from 'routes/Admin/Budget/BudgetManagement/BudgetList/CellRenderers/ProjectionVentilationCellRenderer/hooks/hooks';

import { useModalOptionsContext } from '../optionsContext';
import CommonProjectionVentilationsCellRenderer, {
    ProjectionVentilationRendererParamsT,
} from './CommonProjectionsVentilationsCellRenderer';
import { buildAvailableVentilationsValues } from './helpers/projectionVentilationsOptionsHelpers';
import { useIntegrationSoftwares } from 'helpers/integrations';
import { trackEventAtterrissageVentilationUpdated } from '../../../trackersHelpers';
import { useTranslation } from 'react-i18next';
import { ProjectionVentilation } from 'routes/BudgetModule/components/BudgetProposal/Resource/Projection/helpers/types';
import { ProjectionTypes } from 'routes/Admin/Budget/BudgetManagement/BudgetList/CellRenderers/constants';

export default function ProjectionVentilationsCellRenderer({
    data,
    value: projectionVentilations,
}: ProjectionVentilationRendererParamsT): React.ReactElement {
    const { t } = useTranslation();
    const budgetProposal = data!;
    const { ventilationOptions } = useModalOptionsContext();
    const projectionType = ProjectionTypes.Projection;
    const dropDownTitle = t(
        'adminBudgetSpace.projection.projectionDropdownTitle',
    );
    const updateProjectionByMutation = useUpdateProjectionVentilationMutation(
        budgetProposal.id,
    );

    const { data: softwares = new Set() } = useIntegrationSoftwares();

    const availableValues = useMemo(
        () =>
            buildAvailableVentilationsValues(
                ventilationOptions,
                budgetProposal.by,
                softwares,
            ),
        [ventilationOptions, budgetProposal.by, softwares],
    );

    if (softwares === undefined || !projectionVentilations) {
        return <></>;
    }

    const handleVentilationsMutation = (
        selectedVentilations: ProjectionVentilation.SoftwareIds[],
    ) => {
        updateProjectionByMutation.mutate({
            newVentilation: selectedVentilations,
            ventilationFieldTarget: VentilationType.PROJECTION_BY,
        });
        trackEventAtterrissageVentilationUpdated(
            budgetProposal.id,
            budgetProposal.name,
            selectedVentilations,
        );
    };

    return (
        <CommonProjectionVentilationsCellRenderer
            budgetProposal={budgetProposal}
            initialProjectionVentilations={projectionVentilations}
            dropDownTitle={dropDownTitle}
            availableValues={availableValues}
            projectionType={projectionType}
            handleVentilationsMutation={handleVentilationsMutation}
        />
    );
}
